import React from 'react';
import { StyledHeaderV2 } from './styles';
import { IHeaderV2Props } from './types';
import { EBalancesTheme } from 'utils/enums';
import { Balance } from './Balance/Balance';
import { PlayerLevelImg } from './PlayerLevelImg';

export const StoreHeader = ({
  profilePicUrl,
  onProfilePicClick,
  overrideStore,
  logoPicUrl,
  balances = [],
  balanceQuantityFormat,
  preview = false,
  showHeader = true,
  balanceTheme = EBalancesTheme.DEFAULT,
  profileFrameImg = '',
  backgroundOpacity = 40,
  playerLevelImg = '',
  profilePicBorder = { colorOne: '#FFF' },
  playerName = '',
  showLogo = true,
  showPlayerName = true,
  formatBalanceAmount = {
    balanceFontSize: 14,
    balanceWeight: 400,
    balanceColor: '#FFF',
  },
  formatPlayerName = {
    playerFontSize: 14,
    playerWeight: 400,
    playerTransform: 'none',
  },
  isSticky = false,
}: IHeaderV2Props) => {
  if (!showHeader) return null;

  const isUserInfo = playerName || balances.length > 0;
  const { playerFontSize, playerWeight, playerTransform } = formatPlayerName;
  const { balanceFontSize, balanceWeight, balanceColor } = formatBalanceAmount;

  return (
    <StyledHeaderV2
      profileFrameImg={profileFrameImg}
      backgroundOpacity={backgroundOpacity}
      profilePicBorder={profilePicBorder}
      isSticky={isSticky}
      playerFontSize={playerFontSize}
      playerWeight={playerWeight}
      playerTransform={playerTransform}
    >
      <div className="container">
        <div className="container-user">
          <div className="container-user--pic" onClick={onProfilePicClick}>
            <img
              className="user-pic"
              src={profilePicUrl}
              alt="user-profile-pic"
            />
          </div>
          {isUserInfo && (
            <div className="container-user--info">
              {showPlayerName && playerName && (
                <div className="user-name">{playerName}</div>
              )}
              {balanceTheme && (
                <div className="user-balances">
                  {playerLevelImg && (
                    <PlayerLevelImg
                      balanceTheme={balanceTheme}
                      playerLevelImg={playerLevelImg}
                    />
                  )}
                  {balances?.map(({ image, amount }, index) => (
                    <Balance
                      key={index}
                      image={image}
                      amount={amount}
                      balanceTheme={balanceTheme}
                      balanceQuantityFormat={balanceQuantityFormat}
                      balanceFontSize={balanceFontSize}
                      balanceWeight={balanceWeight}
                      balanceColor={balanceColor}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        {showLogo && logoPicUrl && (
          <div className="container-logo">
            <img
              className="container-logo--img"
              src={logoPicUrl}
              alt="logo"
              onClick={(e) =>
                process.env.NODE_ENV === 'development' &&
                e.detail === 3 &&
                !preview &&
                overrideStore()
              }
            />
          </div>
        )}
      </div>
    </StyledHeaderV2>
  );
};
